import { SCHEDULE_API_BASE_URL } from '../environment';
import { logErrorAndReport } from '../errorReporting';
import HttpRequest from '../request';

class VideoServiceClient extends HttpRequest {
  public async startMeetingCapture(meetingId: string, enaraAuthToken: string) {
    try {
      await this.axiosInstance.post(`/video-call/v2/meeting/${meetingId}/capture`, null, {
        headers: {
          Authorization: `Bearer ${enaraAuthToken}`,
        },
      });

      return true;
    } catch (error) {
      logErrorAndReport({ error });

      return false;
    }
  }
}

const videoServiceClient = new VideoServiceClient(SCHEDULE_API_BASE_URL);

export default videoServiceClient;
